import Trustindex from './components/Trustindex.js';

import TrustindexWidget from './components/TrustindexWidget.js';
import TrustindexReviewWidget from './components/TrustindexReviewWidget.js';
import TrustindexSliderWidget from './components/TrustindexSliderWidget.js';
import TrustindexMasonryWidget from './components/TrustindexMasonryWidget.js';
import TrustindexPopupWidget from './components/TrustindexPopupWidget.js';
import TrustindexTopRatedWidget from './components/TrustindexTopRatedWidget.js';
import TrustindexFomoWidget from './components/TrustindexFomoWidget.js';

import TrustindexCloseModule from './components/TrustindexCloseModule.js';
import TrustindexReadMoreModule from './components/TrustindexReadMoreModule.js';
import TrustindexLoadMoreModule from './components/TrustindexLoadMoreModule.js';
import TrustindexHeaderModule from './components/TrustindexHeaderModule.js';
import TrustindexReviewImageModule from './components/TrustindexReviewImageModule.js';
import TrustindexLightboxModule from './components/TrustindexLightboxModule.js';
import TrustindexAiSummaryModule from './components/TrustindexAiSummaryModule.js';
import TrustindexDarkModeModule from './components/TrustindexDarkModeModule.js';

if (typeof window.TrustindexWidget === 'undefined') {
	window.tiWidgetInstances = [];
	window.Trustindex = Trustindex;

	window.TrustindexWidget = TrustindexWidget;
	window.TrustindexReviewWidget = TrustindexReviewWidget;
	window.TrustindexSliderWidget = TrustindexSliderWidget;
	window.TrustindexMasonryWidget = TrustindexMasonryWidget;
	window.TrustindexPopupWidget = TrustindexPopupWidget;
	window.TrustindexTopRatedWidget = TrustindexTopRatedWidget;
	window.TrustindexFomoWidget = TrustindexFomoWidget;

	window.TrustindexCloseModule = TrustindexCloseModule;
	window.TrustindexReadMoreModule = TrustindexReadMoreModule;
	window.TrustindexLoadMoreModule = TrustindexLoadMoreModule;
	window.TrustindexHeaderModule = TrustindexHeaderModule;
	window.TrustindexReviewImageModule = TrustindexReviewImageModule;
	window.TrustindexLightboxModule = TrustindexLightboxModule;
	window.TrustindexAiSummaryModule = TrustindexAiSummaryModule;
	window.TrustindexDarkModeModule = TrustindexDarkModeModule;

	Trustindex.setConstants();

	let cachedWidth = document.body ? document.body.offsetWidth : 0;
	let resizeTimeout = null;
	window.addEventListener('resize', () => {
		if (document.body.offsetWidth !== cachedWidth) {
			cachedWidth = document.body.offsetWidth;

			if (resizeTimeout) {
				clearTimeout(resizeTimeout);
			}

			resizeTimeout = setTimeout(() => {
				resizeTimeout = null;
				window.tiWidgetInstances.forEach(trustindexWidget => trustindexWidget.resize());
			}, 100);
		}
	});

	document.addEventListener('click', (event) => {
		window.tiWidgetInstances.forEach(TrustindexWidget => TrustindexWidget.documentClick(event));

		let a = event.target.closest('a');
		if (a && a.getAttribute('href')) {
			let navigationToElement = document.getElementById(a.getAttribute('href').split('#')[1]);
			if (navigationToElement && !a.getAttribute('data-ti-enable-scroll')) {
				event.preventDefault();
				event.stopPropagation();
				event.stopImmediatePropagation();

				let targetBounding = navigationToElement.getBoundingClientRect();
				window.tiElementToWaitForVisibility.forEach((element, index) => {
					let widgetBounding = element.getBoundingClientRect();
					if (widgetBounding.top < targetBounding.top) {
						console.log('widget load forced', element);
						new TrustindexWidget(null, element);
						window.tiElementToWaitForVisibility.splice(index, 1);
					}
				});

				a.setAttribute('data-ti-enable-scroll', '1');
				setTimeout(() => a.click(), 150);
			}
		}
	}, { capture: true });

	document.addEventListener('keyup', (event) => {
		window.tiWidgetInstances.forEach(TrustindexWidget => TrustindexWidget.documentKeyup(event));
	});

	// lazy-load
	window.tiElementToWaitForVisibility = [];
	window.tiElementToWaitForActivity = [];

	let scrollCallback = function (event) {
		window.tiElementToWaitForVisibility.forEach((element, index) => {
			if (element.isTriggerLoad()) {
				new TrustindexWidget(null, element);

				window.tiElementToWaitForVisibility.splice(index, 1);
			}
		})
	};

	let interactivityCallback = function(event) {
		window.tiElementToWaitForActivity.forEach((element, index) => {
			window.tiElementToWaitForActivity.splice(index, 1);

			if (true === element.isWaitForVisibility && !element.isTriggerLoad()) {
				return window.tiElementToWaitForVisibility.push(element);
			}

			new TrustindexWidget(null, element);
		});
	};

	window.addEventListener('keydown', interactivityCallback, false);
	window.addEventListener('mousemove', interactivityCallback, false);
	// window.addEventListener('mouseover', interactivityCallback, false);
	window.addEventListener('wheel', interactivityCallback, false);
	window.addEventListener('touchmove', interactivityCallback, false);
	window.addEventListener('touchstart', interactivityCallback, false);

	window.addEventListener('scroll', scrollCallback, false);
	window.addEventListener('wheel', scrollCallback, false);
	window.addEventListener('touchmove', scrollCallback, false);
}

if (typeof window.renderTrustindexWidgets === 'undefined') {
	window.renderTrustindexWidgets = function() {
		// replace pre.ti-widget with its child .ti-widget (for unnecessary <p> workaround)
		document.querySelectorAll('pre.ti-widget').forEach(item => {
			if (item.children.length > 0) {
				item.replaceWith(item.children[0]);
			} else {
				item.remove();
			}
		});

		let initializeWidgets = () => {
			Trustindex.initNoticesForWordpress();
			Trustindex.initWidgetsFromDom();
			Trustindex.loadWidgetsFromDom();
		};

		if (Trustindex.isWordpressAdminUrl()) {
			initializeWidgets();
		} else {
			setTimeout(initializeWidgets, 4);
		}
	};

	if (!Trustindex.isAdminUrl()) {
		let startObserver = function () {
			// render widgets when DOM changes (like from AJAX)
			const observer = new MutationObserver(window.renderTrustindexWidgets);
			observer.observe(document.body, {childList: true, subtree: true});
		};

		if (document.body) {
			startObserver();
		} else {
			let tiInterval = setInterval(() => {
				if (document.body) {
					startObserver();
					clearInterval(tiInterval);
				}
			}, 100);
		}
	}
}

if (!document.currentScript || !document.currentScript.getAttribute('data-skip-init')) {
	window.renderTrustindexWidgets();
}
